import React from 'react';

import { Form, TextField } from '@ui';
import { IOnboardingCreateForm } from '../provider-create-form.schema';
import { useIntl } from 'react-intl';

const GuarantorForm: React.FunctionComponent = () => {
  const { values } = Form.useFormContext<IOnboardingCreateForm>();
  const { formatMessage } = useIntl();

  if (values.servicesType === 'withoutGuarantor') {
    return null;
  }

  return (
    <Form.Section
      label={formatMessage({ id: 'provider.onboarding.form.responsible.person.title' })}
      description={formatMessage({ id: 'provider.onboarding.form.responsible.person.description' })}
    >
      <Form.Field
        name="guarantor.firstName"
        label={formatMessage({ id: 'provider.onboarding.form.responsible.person.firstname' })}
        required
      >
        <TextField />
      </Form.Field>
      <Form.Field
        name="guarantor.lastName"
        label={formatMessage({ id: 'provider.onboarding.form.responsible.person.lastname' })}
        required
      >
        <TextField />
      </Form.Field>
      <Form.Field
        name="guarantor.phoneNumber"
        label={formatMessage({ id: 'provider.onboarding.form.responsible.person.phone' })}
        required
      >
        <TextField autoComplete="tel" type="tel" />
      </Form.Field>
      <Form.Field
        name="guarantor.email"
        label={formatMessage({ id: 'provider.onboarding.form.responsible.person.email' })}
        required
      >
        <TextField type="email" autoComplete="email" />
      </Form.Field>
      <Form.Field
        name="guarantor.doctorCode"
        label={formatMessage({ id: 'provider.onboarding.form.responsible.person.code' })}
        required
      >
        <TextField />
      </Form.Field>
    </Form.Section>
  );
};

export default GuarantorForm;
